import { render, staticRenderFns } from "./AssociateWarningModal.vue?vue&type=template&id=5810a944&"
import script from "./AssociateWarningModal.vue?vue&type=script&lang=js&"
export * from "./AssociateWarningModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports